/* unplugin-vue-components disabled */import { render } from "./wishCard.vue?vue&type=template&id=08ae5e29&scoped=true&ts=true"
import script from "./wishCard.vue?vue&type=script&lang=ts"
export * from "./wishCard.vue?vue&type=script&lang=ts"

import "./wishCard.vue?vue&type=style&index=0&id=08ae5e29&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ae5e29"]])

export default __exports__